export const DOWNLOAD_REGIME_PDF_DEMANDS = ["feature-download-booklet", "$professional-services"]
